var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.7551,
    height: 30.7551,
    rx: 15.3776,
    fill: "#1977F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0966 30.5151C17.2141 30.6726 16.3055 30.7547 15.3777 30.7547C14.5553 30.7547 13.7481 30.6902 12.9607 30.5659V20.2758H8.78754V15.5406H12.9607V11.9315C12.9607 7.82687 15.4129 5.5589 19.1683 5.5589C20.4007 5.57606 21.6303 5.68305 22.847 5.87899V9.91056H20.7735C18.7321 9.91056 18.0966 11.1732 18.0966 12.47V15.5412H22.6546L21.926 20.2758H18.0966V30.5151Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.86e8be8b0e3ce2ff7409603a2e38bffc.svg";
export { ForwardRef as ReactComponent };